import { createSlice } from '@reduxjs/toolkit';

import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAdminDeactivateSupplement,
  handleAdminSupplementRenew,
  handleGetAdminSupplementDetails,
} from './actions';
import { IAdminSupplementDetailsState } from './slice.interface';

const initialState: IAdminSupplementDetailsState = {
  activeId: null,
  data: null,
  isLoading: false,
  isDeactivating: false,
  error: false,
};

export const supplementDetailsSlice = createSlice({
  name: 'admin-supplement-details',
  initialState,
  reducers: {
    removeAdminSupplementInquiryDetails: state => {
      state.activeId = null;
      state.data = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetAdminSupplementDetails.pending,
        (state: IAdminSupplementDetailsState, action) => {
          state.activeId = action.meta.arg;
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(handleGetAdminSupplementDetails.rejected, (state: IAdminSupplementDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetAdminSupplementDetails.fulfilled,
        (state: IAdminSupplementDetailsState, action) => {
          state.data = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(handleAdminSupplementRenew.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_RENEW_SUPPLEMENT_SUBMITTED);
      })
      .addCase(handleAdminDeactivateSupplement.pending, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = true;
      })
      .addCase(handleAdminDeactivateSupplement.rejected, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = false;
      })
      .addCase(handleAdminDeactivateSupplement.fulfilled, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = false;
        eventBus.emit(EventType.ADMIN_DEACTIVATE_SUPPLEMENT_SUCCESS);
      });
  },
});

export const { removeAdminSupplementInquiryDetails } = supplementDetailsSlice.actions;

export default supplementDetailsSlice.reducer;
